import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  userLoginApi,
  userLogoutApi,
  createUserApi,
  getUserApi,
  updateUserApi,
  updateUserPasswordApi,
  userResetPasswordApi,
  setDefaultUserDeliveryAddressApi,
  createUserDeliveryAddressApi,
  updateUserDeliveryAddressApi,
  removeUserDeliveryAddressApi,
  getUserOrderApi,
  checkUserExistenceApi,
  facebookLoginApi,
  verifyOTPApi,
  resendOTPApi,
  sendOTPApi,
  createLoyaltyCustomer,
  fetchOcaUserApi,
  fetchUserViaOddlePassApi,
  getOPAccessTokenApi,
  getOPAddressesApi
} from 'api/fesc/client'
import * as C from './constants'
import { deliveryAddressToAddress } from '@jarvis.oddle/core/tools/address'

export const getOPAccessTokenAction = ({ menuId, customerId }) => asyncAction({
  api: getOPAccessTokenApi,
  requestAction: C.GET_ACCESS_TOKEN_REQUEST,
  successAction: C.GET_ACCESS_TOKEN_SUCCESS,
  failureAction: C.GET_ACCESS_TOKEN_FAILURE
})(() => {
  return { menuId, customerId }
})

export const loginAction = ({ email, password, source }) => asyncAction({
  api: userLoginApi,
  requestAction: C.LOGIN_REQUEST,
  successAction: C.LOGIN_SUCCESS,
  failureAction: C.LOGIN_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { storeOrderId, menuId } } } = metaState
  return { cartName, email, password, source, storeOrderId, menuId }
})

export const fetchOcaUserAction = ({ email, password }) => asyncAction({
  api: fetchOcaUserApi,
  requestAction: C.FETCH_OCA_USER_REQUEST,
  successAction: C.FETCH_OCA_USER_SUCCESS,
  failureAction: C.FETCH_OCA_USER_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { menuId } } } = metaState
  return { cartName, email, password, menuId }
})

export const logoutAction = () => asyncAction({
  api: userLogoutApi,
  requestAction: C.LOGOUT_REQUEST,
  successAction: C.LOGOUT_SUCCESS,
  failureAction: C.LOGOUT_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { storeOrderId } } } = metaState
  return { cartName, storeOrderId }
})

export const signUpAction = (formDetails) => asyncAction({
  api: createUserApi,
  requestAction: C.REGISTER_REQUEST,
  successAction: C.REGISTER_SUCCESS,
  failureAction: C.REGISTER_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { storeOrderId, menuId } } } = metaState
  return { ...formDetails, cartName, storeOrderId, menuId }
})

export const fetchUserFacebookAction = ({ hash }) => asyncAction({
  api: facebookLoginApi,
  requestAction: C.GET_USER_FACEBOOK_REQUEST,
  successAction: C.GET_USER_FACEBOOK_SUCCESS,
  failureAction: C.GET_USER_FACEBOOK_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { storeOrderId } } } = metaState
  return {
    hash,
    cartName,
    storeOrderId
  }
})

export const fetchUserAction = ({ clientId }) => asyncAction({
  api: getUserApi,
  requestAction: C.GET_USER_REQUEST,
  successAction: C.GET_USER_SUCCESS,
  failureAction: C.GET_USER_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName } = metaState
  return { cartName, clientId }
})

export const updateUserAction = ({ email, firstName, lastName, phone, organisationName, receiveEmail, salutation, additionalPhone, gender, dob, source, id: customerId, acceptMarketing, acceptMarketingMenu }) => asyncAction({
  api: updateUserApi,
  requestAction: C.UPDATE_USER_REQUEST,
  successAction: C.UPDATE_USER_SUCCESS,
  failureAction: C.UPDATE_USER_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { menuId } } } = metaState
  return {
    payload: {
      email,
      salutation,
      firstName,
      lastName,
      phone,
      additionalPhone,
      organisationName,
      receiveEmail,
      gender,
      dob,
      source,
      customerId: state.user.data.id || customerId,
      menuId,
      acceptMarketing,
      acceptMarketingMenu
    },
    cartName
  }
})

export const updateUserPasswordAction = (payload) => asyncAction({
  api: updateUserPasswordApi,
  requestAction: C.UPDATE_USER_PASSWORD_REQUEST,
  successAction: C.UPDATE_USER_PASSWORD_SUCCESS,
  failureAction: C.UPDATE_USER_PASSWORD_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { menuId } } } = metaState
  return {
    payload: {
      ...payload,
      customerId: state.user.data.id,
      menuId
    },
    cartName
  }
})

export const resetPasswordAction = (email) => asyncAction({
  api: userResetPasswordApi,
  requestAction: C.RESET_PASSWORD_REQUEST,
  successAction: C.RESET_PASSWORD_SUCCESS,
  failureAction: C.RESET_PASSWORD_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { menuId } } } = metaState
  return { cartName, email, menuId }
})

export const setDefaultUserDeliveryAddressAction = (addressId) => asyncAction({
  api: ({ customerId, addressId, menuId, isEnableOcaAddress }) =>
    isEnableOcaAddress
      ? window.opw.setReferredDeliveryAddress(addressId, customerId)
      : setDefaultUserDeliveryAddressApi({ customerId, addressId, menuId }),
  requestAction: C.SET_DEFAULT_USER_DELIVERY_ADDRESS_REQUEST,
  successAction: C.SET_DEFAULT_USER_DELIVERY_ADDRESS_SUCCESS,
  failureAction: C.SET_DEFAULT_USER_DELIVERY_ADDRESS_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId, oddlePassEnabled, newOddlePassFlow, enableOcaAddress } } } = metaState

  const isEnableOcaAddress = oddlePassEnabled && newOddlePassFlow && enableOcaAddress
  const customerId = isEnableOcaAddress ? state.user.data.ocaId : state.user.data.id

  return { customerId, addressId, menuId, isEnableOcaAddress }
})

export const createUserDeliveryAddressAction = (address) => asyncAction({
  api: ({ cartName, customerId, address, isEnableOcaAddress }) =>
    isEnableOcaAddress
      ? window.opw.createNewAddress(customerId, address)
      : createUserDeliveryAddressApi({ cartName, customerId, address }),
  requestAction: C.CREATE_USER_DELIVERY_ADDRESS_REQUEST,
  successAction: C.CREATE_USER_DELIVERY_ADDRESS_SUCCESS,
  failureAction: C.CREATE_USER_DELIVERY_ADDRESS_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { oddlePassEnabled, newOddlePassFlow, enableOcaAddress } } } = metaState

  const isEnableOcaAddress = oddlePassEnabled && newOddlePassFlow && enableOcaAddress
  const customerId = isEnableOcaAddress ? state.user.data.ocaId : state.user.data.id

  return { cartName, customerId, address, isEnableOcaAddress }
})

export const updateUserDeliveryAddressAction = (address) => asyncAction({
  api: ({ customerId, address, isEnableOcaAddress }) =>
    isEnableOcaAddress
      ? window.opw.updateAddress(address.id, { ...address, customerId })
      : updateUserDeliveryAddressApi({ customerId, address }),
  requestAction: C.UPDATE_USER_DELIVERY_ADDRESS_REQUEST,
  successAction: C.UPDATE_USER_DELIVERY_ADDRESS_SUCCESS,
  failureAction: C.UPDATE_USER_DELIVERY_ADDRESS_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { oddlePassEnabled, newOddlePassFlow, enableOcaAddress } } } = metaState

  const isEnableOcaAddress = oddlePassEnabled && newOddlePassFlow && enableOcaAddress
  const customerId = isEnableOcaAddress ? state.user.data.ocaId : state.user.data.id

  return { customerId, address, isEnableOcaAddress }
})

export const removeUserDeliveryAddressAction = (addressId) => asyncAction({
  api: ({ customerId, addressId, isEnableOcaAddress }) =>
    isEnableOcaAddress
      ? window.opw.deleteAddress(addressId)
      : removeUserDeliveryAddressApi({ customerId, addressId }),
  requestAction: C.REMOVE_USER_DELIVERY_ADDRESS_REQUEST,
  successAction: C.REMOVE_USER_DELIVERY_ADDRESS_SUCCESS,
  failureAction: C.REMOVE_USER_DELIVERY_ADDRESS_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { oddlePassEnabled, newOddlePassFlow, enableOcaAddress } } } = metaState

  const isEnableOcaAddress = oddlePassEnabled && newOddlePassFlow && enableOcaAddress
  const customerId = isEnableOcaAddress ? state.user.data.ocaId : state.user.data.id

  return { customerId, addressId, isEnableOcaAddress }
})

export const fetchUserOrderAction = (orderId) => asyncAction({
  api: getUserOrderApi,
  requestAction: C.GET_USER_ORDER_REQUEST,
  successAction: C.GET_USER_ORDER_SUCCESS,
  failureAction: C.GET_USER_ORDER_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const metaState = getState()['@meta']
  const { cartName, detailMenuSite: { data: { menuId } } } = metaState
  const { user } = state
  return {
    cartName,
    customerId: user.data.id,
    menuId,
    orderId
  }
})

export const checkUserEmailAction = ({ userEmail, source }) => asyncAction({
  api: checkUserExistenceApi,
  requestAction: C.CHECK_USER_EXISTENCE_REQUEST,
  successAction: C.CHECK_USER_EXISTENCE_SUCCESS,
  failureAction: C.CHECK_USER_EXISTENCE_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return { userEmail, source, menuId }
})

export const createThenSetUserDefaultAddressAction = (deliveryAddress) => async (dispatch, getState) => {
  const state = getState()[C.STORE_KEY]
  const { user } = state

  if (!user.fetched) return

  const createResponse = await dispatch(createUserDeliveryAddressAction(deliveryAddressToAddress(deliveryAddress)))
  if (createResponse.success) {
    const response = await dispatch(setDefaultUserDeliveryAddressAction(createResponse.payload.id))
    return response
  }
  return createResponse
}

export const verifyOTPAction = ({ OTP, OTPSessionId, phone }) => asyncAction({
  api: verifyOTPApi,
  requestAction: C.VERIFY_OTP_REQUEST,
  successAction: C.VERIFY_OTP_SUCCESS,
  failureAction: C.VERIFY_OTP_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return {
    OTP,
    OTPSessionId,
    phone,
    menuId
  }
})

export const resendOTPAction = ({ OTPSessionId }) => asyncAction({
  api: resendOTPApi,
  requestAction: C.RESEND_OTP_REQUEST,
  successAction: C.RESEND_OTP_SUCCESS,
  failureAction: C.RESEND_OTP_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return {
    OTPSessionId,
    menuId
  }
})

export const sendOTPAction = ({ phone, purpose = 'API_UPDATE_MEMBERSHIP' }) => asyncAction({
  api: sendOTPApi,
  requestAction: C.SEND_OTP_REQUEST,
  successAction: C.SEND_OTP_SUCCESS,
  failureAction: C.SEND_OTP_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return {
    purpose,
    phone,
    menuId
  }
})

export const createLoyaltyCustomerAction = ({ customerId }) => asyncAction({
  api: createLoyaltyCustomer,
  requestAction: C.CREATE_LOYALTY_CUSTOMER_REQUEST,
  successAction: C.CREATE_LOYALTY_CUSTOMER_SUCCESS,
  failureAction: C.CREATE_LOYALTY_CUSTOMER_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return {
    customerId,
    menuId
  }
})

export const oddlePassV5LoginAction = data => ({ type: C.ODDLE_PASS_LOGIN_SUCCESS, payload: { data } })

export const oddlePassV5LogoutAction = () => ({ type: C.ODDLE_PASS_LOGOUT_SUCCESS })

export const fetchUserViaOddlePassAction = () => asyncAction({
  api: fetchUserViaOddlePassApi,
  requestAction: C.GET_USER_REQUEST,
  successAction: C.GET_USER_SUCCESS,
  failureAction: C.GET_USER_FAILURE
})((getState) => {
  const { cartName } = getState()['@meta']
  return { cartName }
})

export const getAllAddressesOPAction = ({ eatsAccessToken, customerId } = {}) => asyncAction({
  api: getOPAddressesApi,
  requestAction: C.GET_ALL_ADDRESSES_FROM_OP_REQUEST,
  successAction: C.GET_ALL_ADDRESSES_FROM_OP_SUCCESS,
  failureAction: C.GET_ALL_ADDRESSES_FROM_OP_FAILURE
})((getState) => {
  const state = getState()[C.STORE_KEY]
  const { user } = state
  return {
    customerId: customerId || user.data.ocaId,
    eatsAccessToken
  }
})

export const getAllSavedCardsAction = asyncAction({
  api: typeof window !== 'undefined' && window.opw && window.opw.getAllSavedCards,
  requestAction: C.GET_ALL_SAVED_CARDS_FROM_OP_REQUEST,
  successAction: C.GET_ALL_SAVED_CARDS_FROM_OP_SUCCESS,
  failureAction: C.GET_ALL_SAVED_CARDS_FROM_OP_FAILURE
})

export const removeSavedCardAction = asyncAction({
  api: ({ paymentMethodId }) => typeof window !== 'undefined' && window.opw && window.opw.removeSavedCard(paymentMethodId),
  requestAction: C.REMOVE_SAVED_CARD_FROM_OP_REQUEST,
  successAction: C.REMOVE_SAVED_CARD_FROM_OP_SUCCESS,
  failureAction: C.REMOVE_SAVED_CARD_FROM_OP_FAILURE
})

export const setCardDefaultAction = asyncAction({
  api: ({ paymentMethodId }) => typeof window !== 'undefined' && window.opw && window.opw.setCardDefault(paymentMethodId),
  requestAction: C.SET_CARD_DEFAULT_FROM_OP_REQUEST,
  successAction: C.SET_CARD_DEFAULT_FROM_OP_SUCCESS,
  failureAction: C.SET_CARD_DEFAULT_FROM_OP_FAILURE
})

export const saveNewCardAction = asyncAction({
  api: ({ paymentMethodId }) => typeof window !== 'undefined' && window.opw && window.opw.saveNewCard(paymentMethodId),
  requestAction: C.SET_CARD_DEFAULT_FROM_OP_REQUEST,
  successAction: C.SET_CARD_DEFAULT_FROM_OP_SUCCESS,
  failureAction: C.SET_CARD_DEFAULT_FROM_OP_FAILURE
})
